<template>
  <div class="p-1" aria-labelledby="basket-summary-title">
    <div class="basket-container">
      <h2 class="basket-title py-1">
        <span class="text-left">{{ title || $t('subTitle.shoppingCart') }}</span>
      </h2>
    </div>
    <div v-if="basketTile && basketItems.length">

      <div class="basket-list">
        <!-- Render basket products -->
        <div v-for="product in basketItems" :key="product.id">
          <BasketProduct
            :product="product"
            :max="productMaxMap[product.id]"
            :editable="editable"
            @product-quantity-change="onProductQuantityChange"
          />
        </div>
      </div>

      <!-- Payments summary (if available) -->
      <template v-if="basketTile.paymentsList && basketTile.paymentsList.length">
        <div class="basket-payments">
          <div
            v-for="(payment, index) in basketTile.paymentsList"
            :key="'payment-' + index"
            class="payment-row"
          >
            <span>{{ payment.paymentType }}</span>
            <span>-{{ payment.formattedPaymentAmount }}</span>
          </div>
        </div>
      </template>

      <!-- Total price -->
      <h3 class="basket-total normalText mb-0" :class="{'no-vat': !showVat}">
        <span>{{ $t('text.sum') }}:</span>
        <span class="total-price">{{ basketTile.formattedTotal }}</span>
      </h3>

      <!-- VAT summary (if available) -->
      <template v-if="showVat && basketTile.transVats?.vatCodes?.length">
        <div class="basket-vats">
          <div
            v-for="(vat, index) in basketTile.transVats.vatCodes"
            :key="'vat-' + index"
            class="vat-row"
          >
            <span>{{ $t('text.vat') }} {{ vat.formattedVatPercent }}</span>
            <span>{{ vat.formattedVatAmount }}</span>
            <span>{{ vat.formattedNetAmount }}</span>
          </div>
        </div>
      </template>
    </div>
    <div v-else class="empty-basket">
      <p>{{ $t('text.shoppingCartEmpty') }}</p>
    </div>
  </div>
</template>

<script>
import BasketProduct from "@/components/sub-components/Basket/BasketProduct.vue";
import {useAppStore} from "@/stores/app";

export default {
  components: {
    BasketProduct,
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    editable: {
      type: Boolean,
      default: true
    },
    productId: Number,
    basketTile: {
      type: Object,
      required: false,
      default: null
    },
    showVat: {
      type: Boolean,
      default: true
    },
    productMaxMap: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  setup() {
    const appStore = useAppStore();

    return {
      appStore,
    };
  },
  computed: {
    basketItems() {
      return this.basketTile?.basketItems || [];
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    onProductQuantityChange(basketId, quantity) {
      this.$emit('product-quantity-change', basketId, quantity);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/css/customizer';

.basket-container {
  background: var(--custom-basket-group-color, var(--page-group-header));
  margin: 0 auto;
  padding: 0 10px;
  border-radius: var(--button-border-radius);
  width: 100%;
}

.basket-title {
  font-size: 20px;
  color: custom-chain(mealplan-group-color-text,var(--page-group-title));
  display: flex;
  justify-content: space-between; /* Space between the two spans */
  align-items: center; /* Center the text vertically */
  width: 100%; /* Ensure it takes the full width */
}

.basket-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.basket-total {
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  font-weight: bold;
  padding: 12px;
  border-top: 1px solid #ccc;
  margin-top: 12px;
}

.basket-total.no-vat {
  border-top: none;
  margin-top: 0;
}

.total-price {
  color: #0057b8;
}

.basket-vats {
  margin-top: 12px;
  padding: 0 12px;
  font-size: 16px;
}

.vat-row,
.vat-total {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
}

.basket-payments {
  margin-top: 12px;
  padding: 0 12px;
  font-size: 16px;
}

.payment-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
}

.empty-basket {
  text-align: center;
  padding: 20px;
  color: #666;
}
</style>
